// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Al-z","tupacHeader":"Bl-z","tupacHeader2":"Cl-z","tupacMenu":"Dl-z","tupacMenu2":"El-z","tupacMain":"Fl-z","tupacMain2":"Gl-z"};